import { instanceV2 } from '../../api';

const systemNotificationsApi = {
    getActiveCampaigns: (branchId) =>
        instanceV2().get(`/branches/${branchId}/notifications/active`).then(res => res.data),

    getNotification: (notificationId) =>
        instanceV2().get(`/notifications/${notificationId}`).then(res => res.data),

    respond: (branchId, campaignId, body) =>
        instanceV2()
            .post(`/branches/${branchId}/notifications/campaigns/${campaignId}/respond`, body)
            .then(res => res.data),
};

export default systemNotificationsApi;
